// extracted by css-extract-rspack-plugin
export default {"main":"RRSp5","resizing":"iDkka"};